import httpRequest from './http-request';

class VIPAPI {
  constructor() {
    this.domain = `https://vip.wps.cn`;
  }

  /**
   * 是否已经关注公众号
   */
  async isSubscribe() {
    const url = `${this.domain}/wx_adapter/v1/mp/subscribe/wps_learning`;
    const result = await httpRequest.query({
      url,
      options: { methods: 'get', withCredentials: true },
    });
    return result?.msg === 'subscribed';
  }

}

export default new VIPAPI();
